import React from "react";
import "../styles/ProductDetail.css";
import ProductHistory from "./ProductHistory";
import { Producto } from "../types";

interface ProductDetailProps {
  product: Producto;
  onClose: () => void;
  handleEdit: (product: Producto) => void;
}

const ProductDetail: React.FC<ProductDetailProps> = ({ product, onClose, handleEdit }) => {
  return (
    <div className="product-container">
      <h1 className="product-title">{product.nombre}</h1>
      <p><strong>Descripción:</strong> {product.descripcion}</p>
      <p><strong>Marca:</strong> {product.marca || "N/A"}</p>
      <p><strong>Modelo:</strong> {product.modelo || "N/A"}</p>
      <p><strong>Referencia:</strong> {product.referencia}</p>
      <p><strong>Precio de compra:</strong> ${product.precio_compra}</p>
      <p><strong>Precio de venta:</strong> ${product.precio_venta}</p>
      <p><strong>Stock disponible:</strong> {(product as any).Inventario?.stock || 0}</p>
      <p><strong>Ubicación:</strong> {(product as any).Ubicacion?.nombre || "No especificada"}</p>
      <p><strong>Proveedor:</strong> {product.Proveedor?.nombre || "No especificado"}</p>
      <button
        className="button primary"
        onClick={() => handleEdit(product)}
      >
        Editar
      </button>
      <button
        type="button"
        className="button secondary"
        onClick={onClose}
      >
        Cerrar
      </button>
      <ProductHistory productId={product.id} />
    </div>
  );
};

export default ProductDetail;
